import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import EVIncentives from '../../components/EVIncentives/EVIncentives';
import EVJumbotron from '../../client_customizations/components/EVJumbotron/EVJumbotron';
import CostOfOwnership from '../../client_customizations/components/CostOfOwnership/CostOfOwnership';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

const UsedEV = ({ electricVehicles, zipcode }) => {
  const [usedEv, setUsedEv] = useState(null);
  const [usedEvs, setUsedEvs] = useState(null);
  const { evId } = useParams();

  useEffect(() => {
    const setElectricVehicles = () => {
      if (electricVehicles && evId) {
        const evIdParts = evId.split(':');
        const make = evIdParts[0].replace(/_/g, ' ');
        const model = evIdParts[1].replace(/_/g, ' ');
        const trim = evIdParts[2].replace(/_/g, ' ');

        const allUsedEvs = electricVehicles.filter((ev) => {
          return ev.make === make && ev.model === model && ev.trim === trim;
        });
        setUsedEv(allUsedEvs[0]);
        setUsedEvs(allUsedEvs);

        document.title = make ? `Used Vehicle: ${make} ${model}` : '';
      }
    };
    setElectricVehicles();
  }, [electricVehicles, evId]);

  const renderEV = usedEv ? (
    <>
      <EVJumbotron
        car={usedEv}
        incentives={usedEv.incentives}
        cars={usedEvs}
        setUsedEv={setUsedEv}
        backTo="/used-vehicles"
      />
      <CostOfOwnership
        cars={[usedEv, usedEv.equivalent_gas_vehicle]}
        usedEv={true}
        zipcode={zipcode}
      />
      <EVIncentives incentives={usedEv.incentives} car={usedEv} usedEv={true} />
    </>
  ) : (
    <div className="container text-center">
      <LoadingSpinner />
    </div>
  );

  return <>{renderEV}</>;
};

export default UsedEV;

UsedEV.propTypes = {
  electricVehicles: PropTypes.array,
  userLocation: PropTypes.object,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
